module.exports = __webpack_public_path__ + "static/media/icon_service_webmodule.a5f9129c.svg";